var checkForDate = function checkForDate(sortField) {
    var possibleDateNames = ['hour', 'day', 'month', 'year', 'quarter', 'date'];
    return possibleDateNames.some(function (element) {
        return sortField.toLowerCase().indexOf(element) >= 0;
    });
};

export default checkForDate;